import { logError } from '../utils/utils';

export const apiCall = async (hostname, path, method, jwtToken, queryParams, body) => {

  return new Promise((resolve) => {

    let url = `https://${hostname}/${path}`;
    let headers = { 'Content-Type': 'application/json' };

    let requestOptions = {
      method: method,
      headers: headers
    };

    if (jwtToken) {
      headers.Authorization = jwtToken
    }

    if (queryParams) {
      url += '?' + Object.keys(queryParams).map(k => `${k}=${queryParams[k]}`).join('&');
    }

    if (body) {
      requestOptions.body = JSON.stringify(body);
    }

    let responseStatus = 200;
    let responseHeaders = {};
    fetch(url, requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }

        responseStatus = response.status;
        for (const entry of response.headers.entries()) {
          responseHeaders[entry[0]] = entry[1];
        }
        return responseHeaders['content-type'] === 'application/json' ? response.json() : response.text();
      }).then((body) => {
        resolve({
          statusCode: responseStatus,
          headers: responseHeaders,
          data: body
        });
      }).catch(error => {
        logError(error);
        resolve({
          statusCode: 500,
          data: {}
        });
      });
  });
};
